import React, { useEffect, useState, useRef } from 'react';
import './libros_busq.css'
import { useTranslation } from 'react-i18next';
import Modalibro from '../../../components/modalLibro/ModalLibro';

const rut = 'https://www.ricardosalinas.com/images/libros/';

const Libros_busq = ({ contenido }) => {

    const [t, i18n] = useTranslation("biblioteca");
    const [t2] = useTranslation("home");

    const formatDate = (date) => {
        const options = { year: "numeric" };
        return new Date(date).toLocaleDateString(i18n.language, options);
    };

    const openVideoPopup = (videoId) => {
        setCurrentVideoId(videoId);
        setVideoPopupOpen(true);
    };

    const closeVideoPopup = () => {
        setVideoPopupOpen(false);
    };

    // Modal
    const [isModalOpen2, setIsModalOpen2] = useState(false);

    const [variable1, setVariable1] = useState("");
    const [variable2, setVariable2] = useState("");
    const [variable3, setVariable3] = useState("");
    const [variable4, setVariable4] = useState("");
    const [variable5, setVariable5] = useState("");
    const [variable6, setVariable6] = useState("");
    const [variable7, setVariable7] = useState("");
    const [variable8, setVariable8] = useState("");
    const [variable9, setVariable9] = useState("");
    const [variable10, setVariable10] = useState("");

    const openModal2 = (
        value1,
        value2,
        value3,
        value4,
        value5,
        value6,
        value7,
        value8,
        value9,
        idlibro
    ) => {

        setVariable1(value1);
        setVariable2(value2);
        setVariable3(value3);
        setVariable4(value4);
        setVariable5(value5);
        setVariable6(value6);
        setVariable7(value7);
        setVariable8(value8);
        setVariable9(value9);
        setVariable10(idlibro);
        setIsModalOpen2(true);
    };

    const closeModal2 = () => {
        setIsModalOpen2(false);
    };

    const var_img = useRef(0);
    const imageLoaded = () => {
        var_img.current += 1;
    };

    if (!contenido || !contenido.books || contenido.books.length === 0) {
        // Handle the case where `contenido` or `blogNs` is not available or is an empty array.
        return <div></div>;
    }

    return (
        <>
            <h2 _ngcontent-ng-c2327341559="" class="busqueda-page__section-title busqueda-page__section-title-book">{t("header.libros")}</h2>
            <div className="_ngcontent-ng-c3603033847 Libreria libreria-busqueda">
                <section className="biblioteca-books" aria-label="Lista de libros">

                    {
                        contenido.books.map((item, index) => (
                            <div key={index} className="_ngcontent-ng-c54415964 app-biblioteca-book-card">
                                <article role="button" tabIndex="0" className="biblioteca-book-card" onClick={() => openModal2(rut + item.imagen, item.imagen.substring(0, item.imagen.length - 4), item.titulo, item.descripcion, item.autor, item.editorial, formatDate(item.fecha), item.blog, i18n.language, item.id)} >
                                    <div className="biblioteca-book-card__inner">
                                        <div className="biblioteca-book-card__media">
                                            <img loading="lazy" onLoad={imageLoaded} src={rut + item.imagen} alt={item.titulo} />
                                        </div>

                                        <div className="biblioteca-book-card__copy">
                                            
                                            <h3 className="biblioteca-book-card__title">
                                                {item.titulo.split(":")[0]}
                                            </h3>
                                            <p className="biblioteca-book-card__author">{item.autor}</p>
                                            <p className="biblioteca-book-card__summary">
                                                {item.descripcion.substring(0, 155) + "..."}
                                            </p>
                                            <button
                                                className="biblioteca-book-card__link"
                                            >
                                                {t2("2026.bookmore")}
                                            </button>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        ))
                    }
                </section>
                <Modalibro
                    isOpen={isModalOpen2}
                    closeModal={closeModal2}
                    variable1={variable1} //ruta con imagen
                    variable2={variable2} //titulo
                    variable3={variable3} //descripcion
                    variable4={variable4} //autor
                    variable5={variable5} //editorial
                    variable6={variable6} //año
                    variable7={variable7} //año
                    variable8={variable8} //año
                    variable9={variable9} //año
                    id_idea={variable10}
                />
            </div>
        </>
    );

}

export default Libros_busq;